import script from "./Draw-popup.vue?vue&type=script&setup=true&lang=js"
export * from "./Draw-popup.vue?vue&type=script&setup=true&lang=js"

import "./Draw-popup.vue?vue&type=style&index=0&id=b901174a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b901174a"]])

export default __exports__